import _ from 'lodash';

export default class PDFModel {
    constructor(parent, { title, subTitle, shortLink, author, fileNamePrefix } = {}) {
        this.parent = parent;
        this.title = `${title}`;
        this.subTitle = subTitle;
        this.shortLink = shortLink;
        this.author = author;
        this.fileNamePrefix = fileNamePrefix;
    }

    // Takes a page selected to print, applies the template and adds footer, pageNum, etc
    get fileName() {
        return `${this.fileNamePrefix}_${this.localCode}_${_(this.localName).replace(/\s+/g, '')}.pdf`;
    }

    get showPDF() {
        return this.parent.showPDF;
    }

    get version() {
        return this.parent.version;
    }

    get clientInfo() {
        return this.parent.clientInfo;
    }

    set showPDF(value) {
        this.parent.showPDF = value;
    }

    get localCode() {
        return this.parent.region && this.parent.region.localCode;
    }

    get localName() {
        return this.parent.localName;
    }

    get year() {
        return `${this.parent.year}`;
    }

    get additionalReferences() {
        return this.parent.additionalReferences;
    }

    // Above is the PDF Model for use by PDFDownload view
    // Below is the mapping of data for use by PageModels
    get printCategories() {
        let categories = this.parent.pagesModel.pages;
        // Skip first category, that is rendered seperately using introPageModel
        categories = _.takeRight(categories, categories.length - 1);
        const printCategories = _(categories).keyBy('id').mapValues(
            (category) => {
                const sectionModels = category.model && category.model.sectionModels;
                /* eslint-disable no-param-reassign */
                category.printSections = _(sectionModels).keyBy('id').mapValues((printSection) => {
                    printSection.printMetrics = printSection.metricModels && _.keyBy(printSection.metricModels, 'id');
                    return printSection;
                }).value();
                /* eslint-enable no-param-reassign */
                return category;
            }
        );
        return printCategories.value();
    }

    get properties() {
        return {
            title: this.title,
            subject: `${this.localName} ${this.year}`,
            author: this.author,
        };
    }


    //  Page Models for use by PDFDocument
    get titlePageModel() {
        return {
            titles: {
                title: this.title,
                localName: this.localName,
                subTitle: this.subTitle,
                year: this.year,
                shortLink: this.shortLink
            },
            mapSrc: `map_${this.localCode}.svg`,
            colour: 'print.primary.7'
        };
    }

    // Below are utilities for the mapping of models to printed pages
    get introPageModel() {
        return this.parent.pagesModel.pages[0];
    }
}
